import { render, staticRenderFns } from "./UpdateRewardCategory.vue?vue&type=template&id=29685c32"
import script from "./UpdateRewardCategory.vue?vue&type=script&lang=js"
export * from "./UpdateRewardCategory.vue?vue&type=script&lang=js"
import style0 from "./UpdateRewardCategory.vue?vue&type=style&index=0&id=29685c32&prod&lang=css"
import style1 from "./UpdateRewardCategory.vue?vue&type=style&index=1&id=29685c32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports